import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Navbar from '../components/navbar/Navbar';
import { fetchNotificationUnreadCount } from '../features/notifications/model/notificationActions';
import { selectNotificationUnreadCount } from '../features/notifications/model/notificationSelectors';
import { reconcileWebPushOnServer } from '../features/notifications/api/webPush';
import { fetchNotificationPreferences } from '../features/notifications/api/preferences';
import { clearAppBadge, setAppBadgeFromUnreadCount } from '../pwa/appBadge';
import { reconcileWebPushIfEligible } from '../pwa/webPush';
import { selectIsAuthed } from '../selectors/userSelectors';

function MainLayout() {
  const dispatch = useDispatch();
  const isAuthed = useSelector(selectIsAuthed);
  const unreadCount = useSelector(selectNotificationUnreadCount);

  useEffect(() => {
    if (!isAuthed) {
      clearAppBadge();
      return undefined;
    }
    dispatch(fetchNotificationUnreadCount());
    return undefined;
  }, [dispatch, isAuthed]);

  useEffect(() => {
    if (!isAuthed) {
      clearAppBadge();
      return;
    }
    setAppBadgeFromUnreadCount(unreadCount);
  }, [isAuthed, unreadCount]);

  useEffect(() => {
    if (!isAuthed) return undefined;
    let cancelled = false;

    (async () => {
      try {
        const prefs = await fetchNotificationPreferences();
        if (cancelled) return;
        await reconcileWebPushIfEligible({
          isAuthenticated: true,
          serverWebPushEnabled: Boolean(prefs && prefs.web_push_enabled),
          reconcileOnServer: reconcileWebPushOnServer,
        });
      } catch (_err) {
        // Non-fatal — must not block React/auth/WS bootstrap.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isAuthed]);

  return (
    <main id="main-layout">
      <Navbar />
      <Outlet />
    </main>
  );
}

export default MainLayout;
